export const getDOMElements = () => {
  const html = document.documentElement;
  const body = document.body;
  const root = document.getElementById('root');
  const rootContainer = document.querySelector(
    '[class*="rootContainer"]',
  ) as HTMLElement;

  return { html, body, root, rootContainer };
};

export const getInitialViewportHeight = () => {
  return window.visualViewport
    ? window.visualViewport.height
    : window.innerHeight;
};
